import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { WebEDIError } from 'services/webediErrors/types';
import { WithRef } from 'support/types/withRef';
import { Translate } from 'components/Translate/Translate';

import { InfoBlock } from '../../components/InfoBlock';
import { NavigationFooter } from '../../components/NavigationFooter';
import { FieldAnnotationPopoverShell } from '../../FieldAnnotationPopoverShell';
import { ErrorActions } from './ErrorActions';

type Props = {
  isErrorFixed: boolean;
  error: WebEDIError;
  isValidating?: boolean;
  isPendingValidation?: boolean;
  viewMode: boolean;
  fieldDescription?: React.ReactNode;
  style?: React.CSSProperties;
};

export const FieldError = ({
  isErrorFixed,
  error,
  isValidating,
  isPendingValidation,
  viewMode,
  fieldDescription,
  ref,
  style,
}: WithRef<Props, HTMLDivElement>) => {
  const { id: messageId } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const status = isPendingValidation ? 'pending' : isValidating ? 'validating' : isErrorFixed ? 'fixed' : 'error';

  return (
    <FieldAnnotationPopoverShell
      ref={ref}
      style={style}
      status={status}
      title={isErrorFixed ? t('webedi:fieldAnnotation.error.title') : error.title}
      description={
        isErrorFixed ? (
          t('webedi:fieldAnnotation.error.description')
        ) : error.description ? (
          <Translate i18nKey={error.description} />
        ) : null
      }
      info={
        <InfoBlock
          fieldDescription={fieldDescription}
          isErrorFixed={isErrorFixed}
          isPendingValidation={isPendingValidation}
        />
      }
      actions={<ErrorActions messageId={messageId} error={error} isErrorFixed={isErrorFixed} viewMode={viewMode} />}
      footer={<NavigationFooter focusOnly={isErrorFixed} showWhenSingle={isErrorFixed || isPendingValidation} />}
    />
  );
};
